import type { Translation } from '@teamhanko/hanko-elements';

export const tr: Translation = {
    headlines: {
        error: 'Bir hata oluştu',
        accountNotFound: 'Hesap bulunamadı',
        authenticatorApp: 'Kimlik doğrulama uygulaması',
        authenticatorAppAlreadySetUp: 'Kimlik doğrulama uygulaması kuruldu',
        authenticatorAppNotSetUp: 'Kimlik doğrulama uygulamasını kur',
        loginEmail: 'Giriş yap veya hesap oluştur',
        loginEmailNoSignup: 'Giriş yap',
        loginFinished: 'Giriş başarılı',
        loginPasscode: 'Geçiş kodunu gir',
        loginPassword: 'Şifreyi gir',
        registerAuthenticator: 'Geçiş anahtarı oluştur',
        registerConfirm: 'Hesap oluşturulsun mu?',
        registerPassword: 'Yeni şifre belirle',
        securityKeyLogin: 'Güvenlik anahtarı',
        securityKeySetUp: 'Güvenlik anahtarı ekle',
        trustDevice: 'Bu tarayıcıya güvenilsin mi?',
        mfaSetUp: 'Çok faktörlü kimlik doğrulamayı kur',
        otpLogin: 'Kimlik doğrulama kodu',
        otpSetUp: 'Kimlik doğrulama uygulamasını kur',
        profileEmails: 'E-posta adresleri',
        profilePassword: 'Şifre',
        profilePasskeys: 'Geçiş anahtarları',
        isPrimaryEmail: 'Birincil e-posta adresi',
        setPrimaryEmail: 'Birincil e-posta adresi olarak belirle',
        createEmail: 'Yeni bir e-posta adresi gir',
        createUsername: 'Yeni bir kullanıcı adı gir',
        emailVerified: 'Doğrulandı',
        emailUnverified: 'Doğrulanmadı',
        emailDelete: 'Sil',
        renamePasskey: 'Geçiş anahtarını yeniden adlandır',
        deletePasskey: 'Geçiş anahtarını sil',
        lastUsedAt: 'Son kullanım',
        createdAt: 'Oluşturulma tarihi',
        connectedAccounts: 'Bağlı hesaplar',
        deleteAccount: 'Hesabı sil',
        signIn: 'Giriş yap',
        signUp: 'Hesap oluştur',
        selectLoginMethod: 'Giriş yöntemini seç',
        setupLoginMethod: 'Giriş yöntemini kur',
        lastUsed: 'Son görülme',
        ipAddress: 'IP adresi',
        revokeSession: 'Oturumu iptal et',
        profileSessions: 'Oturumlar',
        renameSecurityKey: 'Güvenlik anahtarını yeniden adlandır',
        deleteSecurityKey: 'Güvenlik anahtarını sil',
        securityKeys: 'Güvenlik anahtarları',
        deleteIdentity: 'Bağlantıyı sil',
    },
    texts: {
        authenticatorAppAlreadySetUp:
            'Hesabınız, çok faktörlü kimlik doğrulama için zamana dayalı tek kullanımlık şifreler (TOTP) oluşturan bir kimlik doğrulama uygulamasıyla korunuyor.',
        authenticatorAppNotSetUp:
            'Çok faktörlü kimlik doğrulama için zamana dayalı tek kullanımlık şifreler (TOTP) oluşturan bir kimlik doğrulama uygulamasıyla hesabınızı koruyun.',
        enterPasscode: 'E-posta adresinize gönderilen geçiş kodunu girin.',
        enterPasscodeNoEmail: 'Birincil e-posta adresinize gönderilen geçiş kodunu girin.',
        setupPasskey:
            'Geçiş anahtarıyla hesabınıza kolay ve güvenli bir şekilde giriş yapın. Not: Biyometrik verileriniz yalnızca cihazlarınızda saklanır ve hiçbir zaman kimseyle paylaşılmaz.',
        createAccount: '“{emailAddress}” için hesap bulunamadı. Yeni bir hesap oluşturmak ister misiniz?',
        mfaSetUp:
            'Çok faktörlü kimlik doğrulamayla (MFA) hesabınızı koruyun. MFA, giriş işleminize ek bir adım ekler ve şifreniz veya e-posta hesabınız ele geçirilse bile hesabınızın güvende kalmasını sağlar.',
        noAccountExists: '“{emailAddress}” için hesap bulunamadı.',
        otpEnterVerificationCode: 'Kimlik doğrulama uygulamanızdan aldığınız tek kullanımlık şifreyi (OTP) aşağıya girin:',
        otpLogin: 'Tek kullanımlık şifreyi (OTP) almak için kimlik doğrulama uygulamanızı açın. Girişi tamamlamak için kodu aşağıdaki alana girin.',
        otpScanQRCode: 'QR kodunu Google Authenticator gibi kimlik doğrulama uygulamanızla tarayın. Alternatif olarak OTP gizli anahtarını uygulamaya elle girebilirsiniz.',
        otpSecretKey: 'OTP gizli anahtarı',
        passwordFormatHint: '{minLength} ile {maxLength} karakter arasında olmalıdır.',
        securityKeyLogin:
            'Güvenlik anahtarınızı bağlayın veya etkinleştirin, ardından aşağıdaki düğmeye tıklayın. Hazır olduğunda USB, NFC veya cep telefonunuzla kullanın. Girişi tamamlamak için talimatları izleyin.',
        trustDevice:
            'Bu tarayıcıya güveniyorsanız bir sonraki girişinizde OTP (tek kullanımlık şifre) girmeniz veya çok faktörlü kimlik doğrulama (MFA) için güvenlik anahtarınızı kullanmanız gerekmez.',
        isPrimaryEmail: 'Gerekirse bu e-posta adresi sizinle iletişim kurmak için kullanılacaktır.',
        securityKeySetUp:
            'USB, Bluetooth veya NFC üzerinden özel bir güvenlik anahtarı ya da cep telefonunuzu kullanın. Güvenlik anahtarınızı bağlayın veya etkinleştirin, aşağıdaki düğmeye tıklayın ve kaydı tamamlamak için talimatları izleyin.',
        setPrimaryEmail: 'Sizinle iletişim kurmak için bu e-posta adresini kullanın.',
        emailVerified: 'Bu e-posta adresi doğrulandı.',
        emailUnverified: 'Bu e-posta adresi doğrulanmadı.',
        emailDelete: 'Bu e-posta adresini silerseniz artık giriş yapmak için kullanılamaz.',
        renamePasskey: 'Geçiş anahtarı için bir ad belirleyin.',
        deletePasskey: 'Bu geçiş anahtarını hesabınızdan silin.',
        deleteAccount: 'Bu hesabı silmek istediğinizden emin misiniz? Tüm veriler hemen silinir ve kurtarılamaz.',
        selectLoginMethodForFutureLogins: 'Gelecekteki girişlerde kullanmak için aşağıdaki giriş yöntemlerinden birini seçin.',
        howDoYouWantToLogin: 'Nasıl giriş yapmak istersiniz?',
        deleteSecurityKey: 'Bu güvenlik anahtarını hesabınızdan silin.',
        renameSecurityKey: 'Güvenlik anahtarı için bir ad belirleyin.',
    },
    labels: {
        authenticatorApp: 'Kimlik doğrulama uygulaması',
        authenticatorAppAdd: 'Kur',
        authenticatorAppManage: 'Kimlik doğrulama uygulamasını yönet',
        or: 'veya',
        no: 'hayır',
        yes: 'evet',
        email: 'E-posta',
        continue: 'Devam et',
        copied: 'kopyalandı',
        configured: 'yapılandırıldı',
        skip: 'Atla',
        save: 'Kaydet',
        password: 'Şifre',
        passkey: 'Geçiş anahtarı',
        passcode: 'Geçiş kodu',
        signInPassword: 'Şifreyle giriş yap',
        signInPasscode: 'Geçiş koduyla giriş yap',
        forgotYourPassword: 'Şifrenizi mi unuttunuz?',
        back: 'Geri',
        registerAuthenticator: 'Geçiş anahtarı oluştur',
        securityKey: 'Güvenlik anahtarı',
        securityKeyUse: 'Güvenlik anahtarını kullan',
        signIn: 'Giriş yap',
        signInPasskey: 'Geçiş anahtarıyla giriş yap',
        signUp: 'Hesap oluştur',
        sendNewPasscode: 'Yeni kod gönder',
        staySignedIn: 'Oturumu açık tut',
        trustDevice: 'Bu tarayıcıya güven',
        passwordRetryAfter: '{passwordRetryAfter} sonra tekrar dene',
        passcodeResendAfter: '{passcodeResendAfter} sonra yeni kod iste',
        useAnotherMethod: 'Başka bir yöntem kullan',
        unverifiedEmail: 'doğrulanmamış',
        primaryEmail: 'birincil',
        setAsPrimaryEmail: 'Birincil olarak belirle',
        verify: 'Doğrula',
        delete: 'Sil',
        newEmailAddress: 'Yeni e-posta adresi',
        newPassword: 'Yeni şifre',
        rename: 'Yeniden adlandır',
        newPasskeyName: 'Yeni geçiş anahtarı adı',
        addEmail: 'E-posta ekle',
        createPasskey: 'Geçiş anahtarı oluştur',
        webauthnUnsupported: 'Tarayıcınız geçiş anahtarlarını desteklemiyor',
        signInWith: '{provider} ile devam et',
        deleteAccount: 'Evet, bu hesabı sil.',
        emailOrUsername: 'E-posta veya kullanıcı adı',
        username: 'Kullanıcı adı',
        optional: 'isteğe bağlı',
        dontHaveAnAccount: 'Hesabınız yok mu?',
        alreadyHaveAnAccount: 'Zaten hesabınız var mı?',
        changePassword: 'Şifreyi değiştir',
        setPassword: 'Şifre belirle',
        changeUsername: 'Kullanıcı adını değiştir',
        setUsername: 'Kullanıcı adı belirle',
        revoke: 'İptal et',
        currentSession: 'Geçerli oturum',
        newSecurityKeyName: 'Yeni güvenlik anahtarı adı',
        createSecurityKey: 'Güvenlik anahtarı ekle',
        lastUsed: 'Son kullanım',
        connectAccount: 'Hesap bağla',
    },
    errors: {
        somethingWentWrong: 'Teknik bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
        requestTimeout: 'İstek zaman aşımına uğradı.',
        invalidPassword: 'E-posta veya şifre yanlış.',
        invalidPasscode: 'Girilen geçiş kodu doğru değil.',
        passcodeAttemptsReached: 'Geçiş kodu çok fazla kez yanlış girildi. Lütfen yeni bir kod isteyin.',
        tooManyRequests: 'Çok fazla istek gönderildi. İstenen işlemi tekrarlamadan önce bekleyin.',
        unauthorized: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
        invalidWebauthnCredential: 'Bu geçiş anahtarı artık kullanılamaz.',
        passcodeExpired: 'Geçiş kodunun süresi doldu. Lütfen yeni bir kod isteyin.',
        userVerification: 'Kullanıcı doğrulaması gerekiyor. Kimlik doğrulama cihazınızın PIN veya biyometriyle korunduğundan emin olun.',
        emailAddressAlreadyExistsError: 'E-posta adresi zaten mevcut.',
        maxNumOfEmailAddressesReached: 'Daha fazla e-posta adresi eklenemez.',
        thirdPartyAccessDenied: 'Erişim reddedildi. İstek kullanıcı tarafından iptal edildi veya sağlayıcı başka bir nedenle erişimi reddetti.',
        thirdPartyMultipleAccounts: 'Hesap belirlenemiyor. E-posta adresi birden fazla hesapta kullanılıyor.',
        thirdPartyUnverifiedEmail: 'E-posta doğrulaması gerekiyor. Kullanılan e-posta adresini sağlayıcınızda doğrulayın.',
        signupDisabled: 'Hesap kaydı devre dışı.',
        handlerNotFoundError: 'Sürecinizdeki geçerli adım bu uygulama sürümü tarafından desteklenmiyor. Daha sonra tekrar deneyin veya sorun devam ederse destek ekibiyle iletişime geçin.',
    },
    flowErrors: {
        technical_error: 'Teknik bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
        flow_expired_error: 'Oturumun süresi doldu. Yeniden başlatmak için düğmeye tıklayın.',
        value_invalid_error: 'Girilen değer geçerli değil.',
        passcode_invalid: 'Girilen geçiş kodu doğru değil.',
        passkey_invalid: 'Bu geçiş anahtarı artık kullanılamaz.',
        passcode_max_attempts_reached: 'Geçiş kodu çok fazla kez yanlış girildi. Lütfen yeni bir kod isteyin.',
        rate_limit_exceeded: 'Çok fazla istek gönderildi. İstenen işlemi tekrarlamadan önce bekleyin.',
        unknown_username_error: 'Kullanıcı adı bilinmiyor.',
        unknown_email_error: 'E-posta adresi bilinmiyor.',
        username_already_exists: 'Kullanıcı adı zaten kullanılıyor.',
        invalid_username_error: 'Kullanıcı adı yalnızca harf, rakam ve alt çizgi içerebilir.',
        email_already_exists: 'E-posta zaten kullanılıyor.',
        not_found: 'İstenen kaynak bulunamadı.',
        flow_discontinuity_error: 'Kullanıcı ayarları veya sağlayıcı yapılandırması nedeniyle işleme devam edilemiyor.',
        operation_not_permitted_error: 'İşleme izin verilmiyor.',
        platform_authenticator_required: 'Hesabınız platform kimlik doğrulayıcılarını kullanacak şekilde yapılandırılmış, ancak mevcut cihazınız veya tarayıcınız bu özelliği desteklemiyor. Uyumlu bir cihaz veya tarayıcıyla tekrar deneyin.',
        form_data_invalid_error: 'Gönderilen form verilerinde hatalar var.',
        unauthorized: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
        value_missing_error: 'Değer eksik.',
        value_too_long_error: 'Değer çok uzun.',
        value_too_short_error: 'Değer çok kısa.',
        webauthn_credential_invalid_mfa_only: 'Bu kimlik bilgisi yalnızca ikinci faktör güvenlik anahtarı olarak kullanılabilir.',
        webauthn_credential_already_exists: 'İstek zaman aşımına uğradı, iptal edildi veya cihaz zaten kayıtlı. Lütfen tekrar deneyin ya da başka bir cihaz kullanın.',
        third_party_access_denied: 'Erişim reddedildi. İstek kullanıcı tarafından iptal edildi veya sağlayıcı başka bir nedenle erişimi reddetti.',
    },
};
